import React from "react";
import { WithAPICall } from "../utils/apiUtil";
import {
  Alert,
  AlertTitle,
  Button,
  Card,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import cogoToast from "cogo-toast";
import { LoadingButton } from "@mui/lab";
import { niceDateTime } from "../utils/fn";
import Iconify from "src/components/iconify";
import { View500 } from "src/sections/error";

class CaseList extends React.Component {
  state = { isLoading: true, isError: false, threads: [], currentUser: null };
  componentDidMount() {
    this.getUser();
  }
  createNewCase = async () => {
    this.setState({
      isCreatingCase: true,
    });
    try {
      let res = await this.props.apiCallPost("/harley/createNewCase", {});
      cogoToast.success("Created New Case");
      this.setState(
        {
          newCaseId: res._id,
        },
        () => {
          window.location.href = `/case-notes/${res._id}`;
        }
      );
    } catch (err) {
      cogoToast.error("Error creating a case.");
      this.setState({
        isCreatingCase: false,
      });
    }
  };
  getUser = async () => {
    try {
      let r = await this.props.apiCallPost("/harley/getCurrentUser", {});
      this.setState({ currentUser: r }, () => {
        this.getMyCases();
      });
    } catch (error) {
      this.setState({ currentUser: null, isLoading: false, isError: true });
    }
  };
  getMyCases = async () => {
    try {
      let r = await this.props.apiCallPost("/harley/getMyCases", {});
      this.setState({ threads: r, isLoading: false });
    } catch (error) {
      this.setState({ threads: [], isLoading: false, isError: true });
    }
  };
  renderHeader = () => {
    return (
      <Alert severity="info">
        <AlertTitle>Case Notes Structuring</AlertTitle>
        Use this playground to dictate case notes, and have it be structured
        automatically.
        <br />
        <br />
        <LoadingButton
          variant="contained"
          loading={this.state.isCreatingCase}
          onClick={() => {
            this.createNewCase();
          }}
        >
          New Case
        </LoadingButton>
      </Alert>
    );
  };
  renderTableOfThreads = () => {
    if (this.state.threads.length === 0) {
      return (
        <Card
          sx={{
            boxShadow: 3,
            m: 2,
            p: 2,
            rounded: 2,
          }}
        >
          No cases yet.
        </Card>
      );
    }
    let threads = this.state.threads;
    let isAdmin = this.state.currentUser.isAdmin;

    return (
      <Table size="small">
        {/*   <TableHead>
          <TableRow>
            <TableCell>CAAase</TableCell>
            <TableCell>AA</TableCell>
          </TableRow>
        </TableHead> */}
        <TableBody>
          {threads.map((thread, threadIndex) => {
            let title = thread.title;
            if (!title) {
              title = "New Case";
            }
            let messages = thread.messages;
            let numMessages = messages.length;
            let linkButton = null;

            if (!numMessages) {
              linkButton = (
                <Button
                  variant="contained"
                  color="secondary"
                  href={`/case-notes/${thread._id}`}
                  startIcon={<Iconify icon="iconoir:system-restart" />}
                >
                  Start Case
                </Button>
              );
            }
            let nameElem = null;
            if (isAdmin) {
              nameElem = (
                <Typography variant="caption">
                  {thread?.userId?.name}
                </Typography>
              );
            }
            return (
              <TableRow
                key={threadIndex}
                sx={{
                  "&:hover": {
                    backgroundColor: "#D4F17E",
                  },
                  borderBottom: "2px solid #f0f0f0",
                }}
                onClick={() => {
                  window.location.href = `/case-notes/${thread._id}`;
                }}
              >
                <TableCell>
                  <Stack spacing={1} direction="row" alignItems={"center"}>
                    <Button
                      href={`/case-notes/${thread._id}`}
                      sx={{
                        textDecoration: "none !important",
                        color: "inherit !important",
                        "&:hover": {
                          textDecoration: "none !important",
                        },
                      }}
                    >
                      <Typography variant="overline">{title}</Typography>
                    </Button>
                    {linkButton}
                  </Stack>
                </TableCell>
                <TableCell>
                  <Stack spacing={1}>
                    <Typography variant="overline">
                      {niceDateTime(thread.createdAt)}
                    </Typography>
                    {nameElem}
                  </Stack>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  };
  render() {
    if (this.state.isLoading) {
      return <LinearProgress />;
    }
    if (this.state.isError) {
      return <View500 />;
    }
    return (
      <Stack spacing={2}>
        {this.renderHeader()}
        {this.renderTableOfThreads()}
      </Stack>
    );
  }
}
export default WithAPICall(CaseList);
